import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M19.976 1.686a5.95 5.95 0 0 0-8.3 0l-1.8 1.662a.93.93 0 0 0 0 1.37c.4.39 1 .39 1.4 0l1.7-1.663c1.6-1.466 4-1.466 5.6 0s1.6 4.008.1 5.474l-3 2.933-.4.391c-1.8 1.271-4.3.978-5.6-.782-.3-.39-1-.489-1.4-.195-.4.293-.5.977-.2 1.368 1.2 1.564 3 2.347 4.8 2.347 1.2 0 2.5-.392 3.6-1.174.2-.195.4-.39.7-.586l3-2.933c2.3-2.248 2.2-6.06-.2-8.212m-9.6 14.957-1.7 1.662a4.114 4.114 0 0 1-5.6 0c-1.6-1.466-1.6-4.008-.1-5.474l3-2.933.4-.39c.9-.588 1.9-.88 3-.783 1.1.195 2 .684 2.6 1.564.3.391 1 .49 1.4.196s.5-.978.2-1.369c-1-1.27-2.4-2.053-3.9-2.248-1.5-.294-3.1.097-4.4 1.075l-.6.586-3 2.933c-2.3 2.346-2.2 6.061.1 8.31 1.2 1.075 2.7 1.662 4.2 1.662s3-.587 4.2-1.662l1.7-1.662a.93.93 0 0 0 0-1.369c-.4-.39-1.1-.489-1.5-.098"
    }, null, -1)
  ]))]))
}
export default { render: render }